"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOTIFICATION_PHONE_NUMBER_BODY = exports.MEMBERSHIP_IDENTITY_QUESTION_LABELS = void 0;
const locales_1 = require("../enums/locales");
exports.MEMBERSHIP_IDENTITY_QUESTION_LABELS = {
    [locales_1.Locales.EN]: { Name: "Full Name", Email: "Email" },
    [locales_1.Locales.FR]: { Name: "Nom", Email: "Courriel" },
    [locales_1.Locales.ES]: { Name: "Nombre completo", Email: "Correo electrónico" },
    [locales_1.Locales.DE]: { Name: "Vollständiger Name", Email: "E-Mail" },
};
exports.NOTIFICATION_PHONE_NUMBER_BODY = {
    [locales_1.Locales.EN]: "Phone Number for Notifications",
    [locales_1.Locales.FR]: "Numéro de téléphone pour les notifications",
    [locales_1.Locales.ES]: "Número de teléfono para notificaciones",
    [locales_1.Locales.DE]: "Telefonnummer für Benachrichtigungen",
};
